import Footer from 'components/layout/Footer';

import HeaderMeta from 'components/headerMeta/HeaderMeta';
import React from 'react';
import { buildPageBreadcrumb } from 'untils/jsonLdSchemas';
import AirplaneDisplay from './components/AircraftShowcase';
import JetSaleBanner from './components/JetSaleBanner';
import JetSaleInfo from './components/JetSaleInfo';

import { MainContainer } from './JetSale.style';

const JetSale = () => {
  return (
    <>
      <HeaderMeta type="jetSales" jsonLd={[buildPageBreadcrumb('Jets for Sale', '/jetSale')]} />
      <MainContainer>
        <JetSaleBanner />
        <AirplaneDisplay />
        <JetSaleInfo />
      </MainContainer>
      <Footer />
    </>
  );
};

export default JetSale;
